module.exports = __webpack_public_path__ + "img/byd.4cc82189.svg";